import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { MaterialPriceListService } from '../strategy-price-list.service';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import { LOCALIZED_PROPERTIES, STRATEGY_LIST_EXPORT_ID, STRATEGY_LIST_TITLE } from './strategy-list.constants';
import { ConditionClassEnum } from '../condition-class-enum';

@Injectable()
export class StrategyListExport {
  constructor(
    private exportService: ExportService,
    private strategyListService: MaterialPriceListService,
  ) {}

  private transformItem(item: MaterialPriceListAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      price_list: get(item, 'price_list.count', '0'),
      liquidation_list: get(item, 'liquidation_list.count', '0'),
      promotions_list: get(item, 'promotions_list.count', '0'),
      discount_adjustment: get(item, 'discount_adjustment.count', '0'),
      surcharge_adjustment: get(item, 'surcharge_adjustment.count', '0'),
      discount: get(item, 'discount.count', '0'),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: STRATEGY_LIST_EXPORT_ID,
      title: STRATEGY_LIST_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(STRATEGY_LIST_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;

        this.strategyListService.findByFilter(
          buildQuery(seed(this.strategyListService.currentFilter), page(currentPage, pageSize)),
          { contextHeader: 'export' }
        ).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          const data = get(response, 'data.0.data', []);
          
          data.forEach((item: any) => {
            if (Array.isArray(item.conditionCounts)) {
              item.price_list = item.conditionCounts.find(
                ({ conditionClass, sequenceType }) =>
                  conditionClass === ConditionClassEnum.XP01 && sequenceType === 'S2'
              ) || null;

              item.liquidation_list = item.conditionCounts.find(
                ({ conditionClass, sequenceType }) =>
                  conditionClass === ConditionClassEnum.XP01 && sequenceType === 'S1'
              ) || null;

              item.promotions_list = item.conditionCounts.find(
                ({ conditionClass }) => conditionClass === ConditionClassEnum.XG01
              ) || null;

              item.discount_adjustment = item.conditionCounts.find(
                ({ conditionClass }) => conditionClass === ConditionClassEnum.XC01
              ) || null;

              item.surcharge_adjustment = item.conditionCounts.find(
                ({ conditionClass }) => conditionClass === ConditionClassEnum.XR02
              ) || null;

              item.discount = item.conditionCounts.find(
                ({ conditionClass }) => conditionClass === ConditionClassEnum.XD02
              ) || null;
            }
          });

          data.forEach((item) => {
            ctx.processor.addToSection(STRATEGY_LIST_TITLE, this.transformItem(item));
          });

          ctx.next();
        });
      },
    }).start();
}


  canStartTask() {
    if (this.exportService.taskIsActive(STRATEGY_LIST_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
